var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"set-sku"},[_c('div',{staticClass:"breadcrumb",staticStyle:{"background":"#fff"}},[_vm._v("添加SKU")]),_c('div',{staticClass:"third-title"},[_vm._v("基础设置")])])
}]

export { render, staticRenderFns }